import React, { useEffect, useState, useRef  } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { ALL_PRODUCTS_API, PRODUCT_API, POPULAR_API } from "./apiurls";
import "./WineControls.css";
const GOOGLE_API_KEY  = "AIzaSyAg21sb77epITfWwlAagzu7Gqqth6VJGQk";

function WineControls({
  catId,
  catName,
  cbChangedFilter, 
  cbChangedSort, 
  cbChangeOutputType, 
  cbSearch,
  cbSetUserCoords,
  cbSetNearbyShops,
  categories,
  selectedCatId,
  setSelectedCatId,
  setSelectedCatName,
  showLocationSearch = true,
  showSearchBar = true,
  showPriceFilter = false,
  showCategoryFilter = true,
  showShopFilterInDrawer = false,
} ) {

  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const [shops, setShops] = useState([]);  
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState("Detecting location...");
  const [placeSearch, setPlaceSearch] = useState("");
  const userSelectedPlaceRef = useRef(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [showSearchSuggestions, setShowSearchSuggestions] = useState(false);
  const [itemSelected, setItemSelected] = useState(false);
  const placeRef = useRef(null);
  const [selectedPlace, setSelectedPlace] = useState("");
  const locationInputRef = useRef(null);
  const [showFilters, setShowFilters] = useState(false);
  const [activeFilterTab, setActiveFilterTab] = useState("category");
  const [tempCategoryId, setTempCategoryId] = useState(
    selectedCatId || "ALL"
  );
  const [tempShop, setTempShop] = useState([]);
  const [tempSizes, setTempSizes] = useState([]);
  const [tempPrices, setTempPrices] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");

  useEffect(() => {
    setActiveFilterTab(
        showShopFilterInDrawer ? "shop" : "category"
    );
  }, [showShopFilterInDrawer]);

  useEffect(() => {
    setFilterSearch("");
  }, [activeFilterTab]);

  const priceRanges = [
    { label: "₹0 - ₹500", from: 0, to: 500 },
    { label: "₹500 - ₹1000", from: 500, to: 1000 },
    { label: "₹1000 - ₹1500", from: 1000, to: 1500 },
    { label: "₹1500+", from: 1500, to: "" }
  ];

  useEffect(() => {
    setTempCategoryId(selectedCatId || "ALL");
  }, [selectedCatId]);

const categoryLabel = "Search products, brands, categories....";

useEffect(() => {
    setSearchValue("");
}, [location]);
  
 const searchLocation = async (query) => {
  if (!query.trim()) {
    setLocationSuggestions([]);
    return;
  }

  try {
    const res = await fetch(
      `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=5`
    );

    const data = await res.json();

    const results = data.features.map((f) => ({
      name: [
        f.properties.name,
        f.properties.city,
        f.properties.state
      ]
        .filter(Boolean)
        .join(", "),
      lat: f.geometry.coordinates[1],
      lng: f.geometry.coordinates[0]
    }));

    setLocationSuggestions(results);
    setShowLocationSuggestions(true);
  } catch (err) {
    console.error(err);
  }
};
const selectLocation = async (loc) => {
  setCurrentLocation(loc.name);

  cbSetUserCoords({
    lat: loc.lat,
    lng: loc.lng
  });

  localStorage.setItem(
    "userLocation",
    JSON.stringify({
      lat: loc.lat,
      lng: loc.lng,
      address: loc.name
    })
  );

  setShowLocationSuggestions(false);

  fetchNearbyShops(loc.lat, loc.lng);
};
const detectLocation = () => {
  if (!navigator.geolocation) {
    setCurrentLocation("Geolocation not supported");
    return;
  }

  setCurrentLocation("Detecting location...");

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude, accuracy } = position.coords;

      console.log(
        "Latitude:", latitude,
        "Longitude:", longitude,
        "Accuracy:", accuracy
      );

      await handleValidLocation(
        latitude,
        longitude,
        accuracy
      );
    },
    (error) => {
      console.error(error);

      switch (error.code) {
        case error.PERMISSION_DENIED:
          setCurrentLocation("Location permission denied");
          break;

        case error.POSITION_UNAVAILABLE:
          setCurrentLocation("Location unavailable");
          break;

        case error.TIMEOUT:
          setCurrentLocation("Location request timed out");
          break;

        default:
          setCurrentLocation("Unable to detect location");
      }
    },
    {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    }
  );
};
const fallbackToIP = async () => {
  try {
    setCurrentLocation("Getting approximate location...");

    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();

    console.log("🌐 RAW IP DATA:", data);

    if (!data || !data.latitude || !data.longitude) {
      throw new Error("Invalid IP location");
    }

    console.log("🌐 IP Location:", data.latitude, data.longitude);

    await handleValidLocation(data.latitude, data.longitude);

  } catch (err) {
    console.error("❌ IP fallback failed", err);
    setCurrentLocation("Unable to detect location");
  }
};

const handleValidLocation = async (lat, lng, accuracy) => {
  try {
    cbSetUserCoords({ lat, lng });

    const geoRes = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
    );

    const geo = await geoRes.json();

    const address =
      geo.display_name || "Unknown Location";

    setCurrentLocation(address);

    localStorage.setItem(
      "userLocation",
      JSON.stringify({
        lat,
        lng,
        address,
        accuracy
      })
    );

    fetchNearbyShops(lat, lng);

  } catch (err) {
    console.error(err);
    setCurrentLocation("Location fetch failed");
  }
};
  const fetchNearbyShops = async (lat, lng) => {

  console.log("📍 Sending to API");
  console.log("Latitude:", lat);
  console.log("Longitude:", lng);

  try {
    const res = await fetch(
      "https://gitstool.in/liquor/shop_app/get_nearby_shops.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lat, lng })
      }
    );

    const data = await res.json();
    console.log("Nearby shops:", data);

    cbSetNearbyShops(data);

  } catch (err) {
    console.error(err);
  }
};
  useEffect(() => {
    console.log("🔥 useEffect triggered");
    const saved = localStorage.getItem("userLocation");

if (saved) {
  const savedData = JSON.parse(saved);

  const { lat, lng, address, accuracy } = savedData;

  console.log("💾 Using saved location:", lat, "Accuracy:", accuracy);

  setCurrentLocation(address);
  cbSetUserCoords({ lat, lng });
  fetchNearbyShops(lat, lng);

  // 🔥 If accuracy missing → refresh once
  if (accuracy === undefined) {
    console.log("⚠️ Old location found → upgrading accuracy...");
    detectLocation();
  }

  return;
}  
      detectLocation();
    
  }, []);
 
  /* ================= PLACE AUTOCOMPLETE (EXACT LIKE HTML) ================= */
  
 // Fetch shop names dynamically based on catId
 useEffect(() => {
  async function fetchShops() {
    try {
      let url = "";

      if (catId === "ALL") {
        url = ALL_PRODUCTS_API;
      } else if (catId === "POPULAR") {
        url = POPULAR_API;
      } else {
        url =PRODUCT_API.replace("${cat_id}", catId);
      }

      const res = await fetch(url);
      const data = await res.json();

      // ✅ UNIQUE SHOPS BY bm_id
      const shopMap = new Map();

data.forEach(item => {
  if (item.shop) {
    const normalizedShop = item.shop.trim().toLowerCase();

    if (!shopMap.has(normalizedShop)) {
      shopMap.set(normalizedShop, {
        shop: item.shop.trim()
      });
    }
  }
});

setShops(Array.from(shopMap.values()));
    } catch (err) {
      console.error("Failed to fetch shops", err);
    }
  }

  fetchShops();
}, [catId]);

 function handleSearch(event) {
    const value = event.target.value;
    setSearchValue(value);
    setItemSelected(false);
    cbSearch(value);
  }
  useEffect(() => {
    if (!searchValue.trim()) {
      setSearchSuggestions([]);
      setShowSearchSuggestions(false);
      return;
    }

     const timeout = setTimeout(async () => {

      try {

        const res = await fetch(ALL_PRODUCTS_API);
        const data = await res.json();

      const keywords = searchValue
  .toLowerCase()
  .trim()
  .split(/\s+/);

const matches = data.filter(p => {

  const text = `${p.brand_nm || ""} ${p.cat_name || ""} ${p.shop || ""}`.toLowerCase();

  const textNoSpace = text.replace(/\s+/g, "");

  return keywords.every(k =>
    text.includes(k) || textNoSpace.includes(k)
  );

});;setSearchSuggestions(matches.slice(0, 6));

        setShowSearchSuggestions(true);

      } catch (e) {

        console.error("Search suggestion error", e);

      }

    }, 300);

    return () => clearTimeout(timeout);
  }, [searchValue]);
    const selectSuggestion = (p) => {

    setSearchValue(p.brand_nm);

    cbSearch(p.brand_nm);

    setItemSelected(true);

    setShowSearchSuggestions(false);

  };

  return (
    <div className="wine-controls-wrapper">
       
    {showSearchBar && (
  <div className="search-filter-row">

    <div className="search-input-wrap">

      <input
        type="text"
        placeholder={categoryLabel}
        value={searchValue}
        onChange={handleSearch}
        onKeyDown={e => {
          if (e.key === "Enter") {
            cbSearch(searchValue);
          }
        }}
      />

      {/* {!itemSelected && showSearchSuggestions && searchSuggestions.length > 0 && (
        <div className="search-suggestions">
          {searchSuggestions.map(p => (
            <div
              key={p.bm_id}
              className="search-suggestion-item"
              onClick={() => selectSuggestion(p)}
            >
              <strong>{p.brand_nm}</strong>
              <span className="muted">
                • {p.cat_name} • {p.shop}
              </span>
            </div>
          ))}
        </div>
      )} */}

    </div>

    <button
      className="filters-btn"
      onClick={() => setShowFilters(true)}
    >
      <span>☰</span> Filters
    </button>

  </div>
)}
    
      {showLocationSearch && (
      <>
      <div className="location-row">
        <button
        className="loc-btn"
        onClick={() => {
          localStorage.removeItem("userLocation"); // clear old
          detectLocation();
  }}
>
          Use current location
        </button>
     <div className="location-search-wrap">
  <input
    type="text"
    placeholder="Search your location"
    className="loc-search"
    value={placeSearch}
    onChange={(e) => {
      setPlaceSearch(e.target.value);
      searchLocation(e.target.value);
    }}
  />

  {showLocationSuggestions &&
    locationSuggestions.length > 0 && (
      <div className="search-suggestions">
        {locationSuggestions.map((loc, idx) => (
          <div
            key={idx}
            className="search-suggestion-item"
            onClick={() => selectLocation(loc)}
          >
            {loc.name}
          </div>
        ))}
      </div>
    )}
</div>
      
</div>
      <div className="curr-location"><p>{currentLocation}</p></div>
       </>
)}
      
    {showFilters && (
  <>
    {/* OVERLAY */}
    <div
      className="filter-overlay"
      onClick={() => setShowFilters(false)}
    />

    {/* FILTER DRAWER */}
    <div className="filter-drawer">

      {/* ---------- HEADER ---------- */}
      <div className="drawer-header">

        <h3>
          {activeFilterTab === "category" && "Category"}
          {activeFilterTab === "shop" && "All Vends"}
          {activeFilterTab === "size" && "Size"}
          {activeFilterTab === "price" && "Price"}
        </h3>

        <div className="drawer-header-actions">

          <button
            className="clear-filter-btn"
            onClick={() => {
              setFilterSearch("");

              if (activeFilterTab === "category") {
                setTempCategoryId("ALL");
              }

              if (activeFilterTab === "shop") {
                setTempShop([]);
              }

              if (activeFilterTab === "size") {
                setTempSizes([]);
              }

              if (activeFilterTab === "price") {
                setTempPrices([]);
              }
            }}
          >
            Clear
          </button>

          <button
            className="drawer-close"
            onClick={() => setShowFilters(false)}
          >
            ✕
          </button>

        </div>
      </div>

      {/* ---------- SEARCH INSIDE FILTER ---------- */}
      <div className="filter-search-wrap">
        <input
          type="text"
          className="filter-search-input"
          value={filterSearch}
          onChange={(e) => setFilterSearch(e.target.value)}
          placeholder={
            activeFilterTab === "category"
              ? "Search categories..."
              : activeFilterTab === "price"
              ? "Search price..."
              : activeFilterTab === "shop"
              ? "Search vends..."
              : activeFilterTab === "size"
              ? "Search size..."
              : "Search..."
          }
        />
      </div>

      {/* ---------- DRAWER CONTENT ---------- */}
      <div className="drawer-content">

        {/* ---------- LEFT TAB MENU ---------- */}
        <div className="drawer-tabs">

          {showCategoryFilter && (
            <button
              className={
                activeFilterTab === "category"
                  ? "drawer-tab active"
                  : "drawer-tab"
              }
              onClick={() => setActiveFilterTab("category")}
            >
              Category
            </button>
          )}

          {showShopFilterInDrawer && (
            <button
              className={
                activeFilterTab === "shop"
                  ? "drawer-tab active"
                  : "drawer-tab"
              }
              onClick={() => setActiveFilterTab("shop")}
            >
              All Vends
            </button>
          )}

          {/* Size is available on the product filters */}
          <button
            className={
              activeFilterTab === "size"
                ? "drawer-tab active"
                : "drawer-tab"
            }
            onClick={() => setActiveFilterTab("size")}
          >
            Size
          </button>

          {showPriceFilter && (
            <button
              className={
                activeFilterTab === "price"
                  ? "drawer-tab active"
                  : "drawer-tab"
              }
              onClick={() => setActiveFilterTab("price")}
            >
              Price
            </button>
          )}

        </div>

        {/* ---------- RIGHT OPTIONS ---------- */}
        <div className="drawer-options">

          {/* ================= CATEGORY ================= */}
          {activeFilterTab === "category" && (
            <div className="filter-options">

              {/* ALL */}
              <label className="filter-option">

                <input
                  type="radio"
                  name="category-filter"
                  checked={tempCategoryId === "ALL"}
                  onChange={() => setTempCategoryId("ALL")}
                />

                <span>ALL</span>

              </label>

              {/* CATEGORIES */}
              {(categories || [])
                .filter((cat) => {
                  const search = filterSearch
                    .trim()
                    .toLowerCase();

                  if (!search) return true;

                  return String(cat.cat_name || "")
                    .toLowerCase()
                    .includes(search);
                })
                .map((cat) => (

                  <label
                    key={cat.cat_id}
                    className="filter-option"
                  >

                    <input
                      type="radio"
                      name="category-filter"
                      checked={
                        String(tempCategoryId) ===
                        String(cat.cat_id)
                      }
                      onChange={() =>
                        setTempCategoryId(cat.cat_id)
                      }
                    />

                    <span>{cat.cat_name}</span>

                  </label>

                ))}

            </div>
          )}

          {/* ================= SHOP ================= */}
          {activeFilterTab === "shop" && (
            <div className="filter-options">

              {(shops || [])
                .filter((item) => {
                  const search = filterSearch
                    .trim()
                    .toLowerCase();

                  if (!search) return true;

                  return String(item.shop || "")
                    .toLowerCase()
                    .includes(search);
                })
                .map((item) => {

                  const shopName = item.shop;

                  return (
                    <label
                      key={shopName}
                      className="filter-option"
                    >

                      <input
                        type="checkbox"
                        checked={tempShop.includes(shopName)}
                        onChange={() => {
                          setTempShop((prev) =>
                            prev.includes(shopName)
                              ? prev.filter(
                                  (shop) =>
                                    shop !== shopName
                                )
                              : [...prev, shopName]
                          );
                        }}
                      />

                      <span>{shopName}</span>

                    </label>
                  );
                })}

            </div>
          )}

          {/* ================= SIZE ================= */}
          {activeFilterTab === "size" && (
            <div className="filter-options">

              {[
                "750ML",
                "375ML",
                "180ML"
              ]
                .filter((size) => {
                  const search = filterSearch
                    .trim()
                    .toLowerCase();

                  if (!search) return true;

                  return size
                    .toLowerCase()
                    .includes(search);
                })
                .map((size) => (

                  <label
                    key={size}
                    className="filter-option"
                  >

                    <input
                      type="checkbox"
                      checked={tempSizes.includes(size)}
                      onChange={() => {
                        setTempSizes((prev) =>
                          prev.includes(size)
                            ? prev.filter(
                                (item) => item !== size
                              )
                            : [...prev, size]
                        );
                      }}
                    />

                    <span>{size}</span>

                  </label>

                ))}

            </div>
          )}

          {/* ================= PRICE ================= */}
          {activeFilterTab === "price" && (
            <div className="filter-options">

              {priceRanges
                .filter((price) => {
                  const search = filterSearch
                    .trim()
                    .toLowerCase();

                  if (!search) return true;

                  return (
                    String(price.label)
                      .toLowerCase()
                      .includes(search) ||
                    String(price.from)
                      .toLowerCase()
                      .includes(search) ||
                    String(price.to)
                      .toLowerCase()
                      .includes(search)
                  );
                })
                .map((price) => (

                  <label
                    key={price.label}
                    className="filter-option"
                  >

                    <input
                      type="checkbox"
                      checked={tempPrices.some(
                        (item) =>
                          item.from === price.from &&
                          item.to === price.to
                      )}
                      onChange={() => {

                        setTempPrices((prev) => {

                          const exists = prev.some(
                            (item) =>
                              item.from === price.from &&
                              item.to === price.to
                          );

                          if (exists) {
                            return prev.filter(
                              (item) =>
                                !(
                                  item.from === price.from &&
                                  item.to === price.to
                                )
                            );
                          }

                          return [
                            ...prev,
                            {
                              from: price.from,
                              to: price.to
                            }
                          ];

                        });

                      }}
                    />

                    <span>{price.label}</span>

                  </label>

                ))}

            </div>
          )}

        </div>
      </div>

      {/* ---------- APPLY ---------- */}
      <button
        className="apply-filter-btn"
        onClick={() => {

          // ================= CATEGORY =================

          setSelectedCatId(tempCategoryId);

          const selectedCategory =
            (categories || []).find(
              (cat) =>
                String(cat.cat_id) ===
                String(tempCategoryId)
            );

          setSelectedCatName(
            tempCategoryId === "ALL"
              ? "ALL"
              : selectedCategory?.cat_name || "ALL"
          );

          // ================= SHOPS =================

          cbChangedFilter(tempShop);

          // ================= SIZE + PRICE =================

          cbChangedSort({
            sizes: tempSizes,
            prices: tempPrices
          });

          // ================= CLOSE =================

          setShowFilters(false);
        }}
      >
        Apply
      </button>

    </div>
  </>
)}
    </div>
  );
  
 }

WineControls.propTypes = {
  catId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cbChangedFilter: PropTypes.func.isRequired,
  cbChangedSort: PropTypes.func.isRequired,
  cbChangeOutputType: PropTypes.func.isRequired,
   cbSearch: PropTypes.func.isRequired,
   cbSetUserCoords: PropTypes.func.isRequired,
   cbSetNearbyShops: PropTypes.func.isRequired
};

export default WineControls;